module.exports = __webpack_public_path__ + "img/art_side.7741a768.png";